import validateField from 'cerebral-module-forms/factories/validateField'

function validateCurrentField() {
  let action = context => {
    let input = context.input
    validateField(`${input.field}`)(context)
  }

  action.displayName = 'validateCurrentField'
  return action
}

export default validateCurrentField



// WEBPACK FOOTER //
// ./src/modules/client/actions/validateCurrentField.js